import React from 'react'
import useStore from '../store'
import Fuse from 'fuse.js';
import postcodes from "../assets/data/au_postcodes.json";
import PostcodeResult from './PostcodeResult';

const HospitalSearch = () => {

    function clearInputField(inputId) {
        document.getElementById(inputId).value = '';
    }

    const postcodeResults = useStore((state) => state.postcodeResults);
    const setPostcodeResults = useStore((state) => state.setPostcodeResults);
    const setPostcodeUser = useStore((state) => state.setPostcodeUser);
    const setPostcodeSelected = useStore((state) => state.setPostcodeSelected);
    const setSuburbUser = useStore((state) => state.setSuburbUser);
    const setPostcodeUserLong = useStore((state) => state.setPostcodeUserLong);
    const setPostcodeUserLat = useStore((state) => state.setPostcodeUserLat);
    const setStateCode = useStore((state) => state.setStateCode);

    const fuse = new Fuse(postcodes, {
        minMatchCharLength: 4,
        threshold: 0.1,
        keys: [
            'postcode',
            'place_name'
        ]
    });

    const fuzzySearch = () => {
        const searchTerm = document.getElementById('postcodeSearch').value;
        if (searchTerm.length < 4) {
            setPostcodeResults([])
            return;
        }
        const results = fuse.search(searchTerm);
        if (results.length === 0) {
            alert("No results found, please check your postcode")
        } else {
            setPostcodeResults(results);
        }
    }

    const displayPostcodeResults = () => {
        if (postcodeResults.length) {
            return (
                <div className='flex flex-col space-y-2 bg-gray-100/50 backdrop-blur-2xl shadow-md rounded-xl overflow-auto absolute top-9 w-full max-h-48 border z-40'>
                    {postcodeResults.map((result, index) => <PostcodeResult placeName={result.item.place_name} postcode={result.item.postcode} long={result.item.longitude} lat={result.item.latitude} stateCode={result.item.state_code} key={index} />)}
                </div>
            )
        }
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          fuzzySearch(e.target.value);
        }
      };

    const resetForm = () => {
        clearInputField('postcodeSearch');
        setPostcodeUser('');
        setSuburbUser('');
        setPostcodeUserLong('');
        setPostcodeUserLat('');
        setPostcodeResults([]);
        setPostcodeSelected(false);
        setStateCode('');

    }

    return (
        <div className='flex flex-col space-y-2 relative'>
            <input type="text" id='postcodeSearch' name='postcode' placeholder="Enter your postcode" onChange={() => fuzzySearch()} className='border rounded-xl p-3' onKeyDown={handleKeyDown} minLength={3} maxLength={4}/>
            <div className='flex justify-between space-x-4'>
                <button onClick={() => resetForm()} className='p-2 bg-gray-200 rounded-xl grow'>Reset</button>
                {/* <button className='p-2 bg-[#2d3389] rounded-xl text-white grow' onClick={() => fuzzySearch(document.getElementById('postcodeSearch').value)}>Search</button> */}
            </div>
            {displayPostcodeResults()}
        </div>
    )
}

export default HospitalSearch